import { useState } from 'react';
import { REMEMBERED_USERNAME_KEY } from '../constants/auth.constants';

function readRememberedUsername(): string {
  try {
    return localStorage.getItem(REMEMBERED_USERNAME_KEY) ?? '';
  } catch {
    return '';
  }
}

function writeRememberedUsername(username: string | null): void {
  try {
    if (username === null) {
      localStorage.removeItem(REMEMBERED_USERNAME_KEY);
      return;
    }
    localStorage.setItem(REMEMBERED_USERNAME_KEY, username);
  } catch {
    return;
  }
}

interface UseRememberedUsername {
  rememberedUsername: string;
  isRemembering: boolean;
  setIsRemembering: (isRemembering: boolean) => void;
  persistUsername: (username: string) => void;
}

export function useRememberedUsername(): UseRememberedUsername {
  const [rememberedUsername] = useState(readRememberedUsername);
  const [isRemembering, setRemembering] = useState(rememberedUsername !== '');

  function setIsRemembering(next: boolean): void {
    setRemembering(next);
    if (!next) writeRememberedUsername(null);
  }

  function persistUsername(username: string): void {
    if (isRemembering) writeRememberedUsername(username);
  }

  return { rememberedUsername, isRemembering, setIsRemembering, persistUsername };
}
